import { FormBase } from 'core/components';

export default class CustomLabelForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.setForm(this);
	}
	setup() {
		return {
			fields: [
				'carrierTypeId',
				'useCustomReturnAddress',
				'returnName',
				'returnPhone',
				'sellerName',
				'sellerPhone',
				'attentionName',
				'returnAddress',
				'returnCity',
				'returnZip',
				'returnStateId',
				'customFieldInputs',
				'customFieldInputs[].id',
				'customFieldInputs[].value',
				'customFieldInputs[].fieldNumber',
				'customFieldInputs[].lastIndex',
				'customFieldInputs[].displayDropdown',
				'customFieldInputs[].previousValue',
				'customFieldInputs[].customFieldInputVariables',
				'customFieldInputs[].customFieldInputVariables[].id',
				'customFieldInputs[].customFieldInputVariables[].customFieldVariableId',
				'customFieldInputs[].customFieldInputVariables[].customFieldInputId',
				'customFieldInputs[].customFieldInputVariables[].position',
			],
			labels: {
				carrierTypeId: 'Preview',
				useCustomReturnAddress: '',
				returnName: 'CUSTOMLABEL.RETURNNAME',
				returnPhone: 'CUSTOMLABEL.RETURNPHONE',
				sellerName: 'CUSTOMLABEL.SELLERNAME',
				sellerPhone: 'CUSTOMLABEL.SELLERPHONE',
				returnAddress: 'CUSTOMLABEL.RETURNADDRESS',
				returnCity: 'CUSTOMLABEL.RETURNCITY',
				returnZip: 'CUSTOMLABEL.RETURNZIP',
				returnStateId: 'CUSTOMLABEL.RETURNSTATE',
				attentionName: 'CUSTOMLABEL.ATTENTIONNAME',
			},
			rules: {
				sellerName: 'required',
				sellerPhone: 'required',
			},
			initials: {
				useCustomReturnAddress: false,
			},
			types: {
				useCustomReturnAddress: 'checkbox',
			},
		};
	}
}
